import { clampValue } from '../../../utils/bar';
import { c } from '../../../utils/tailwind-merge';
import { BarProps } from './Bar.types';

export const Bar = ({
  value,
  max,
  ariaLabel,
  renderInnerBar = true,
  className,
}: BarProps) => {
  const intMax = Math.round(max);
  const intValue = Math.round(value);

  const safeMax = intMax > 0 ? intMax : 1;
  const safeValue = clampValue(intValue, 0, safeMax);
  const barPercentage = (safeValue / safeMax) * 100;

  return (
    <div
      className={c('h-4 w-72 rounded bg-grey-100', className)}
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-valuenow={safeValue}
      role="meter"
      data-slot="bar-fill"
    >
      {renderInnerBar ? (
        <div
          className={c('h-4 rounded bg-blue')}
          style={{ width: `${barPercentage}%` }}
          aria-hidden="true"
        ></div>
      ) : null}
    </div>
  );
};
